<template>
  <ul :class="['simpleLinkList', { series }]">
    <li class="simpleLinkList_item" v-for="item in items" :key="item.link">
      <template v-if="item.link === '/logout'">
        <a
          :href="item.link"
          class="simpleLinkList_link"
          @click.prevent="$store.commit('applyLogout')"
        >
          <span>{{ item.heading }}</span>
          <span v-if="item.label" class="simpleLinkList_label">
            {{ item.label }}
          </span>
        </a>
      </template>
      <template v-else>
        <router-link
          v-if="!series || (series && !item.current)"
          :to="item.link"
          class="simpleLinkList_link"
          :class="item.label ? '-hasLabel' : ''"
        >
          <span>{{ item.heading }}</span>
          <span v-if="item.label" class="simpleLinkList_label">
            {{ item.label }}
          </span>
        </router-link>
        <div class="simpleLinkList_link current" v-if="series && item.current">
          <span>{{ item.heading }}</span>
        </div>
      </template>
    </li>
  </ul>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'

type SimpleLinkListItems = {
  link: string
  heading: string
  label?: string
  current?: boolean
}[]

export default defineComponent({
  name: 'SimpleLinkList',

  props: {
    items: Array as PropType<SimpleLinkListItems>,
    series: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.simpleLinkList {
  margin-top: 24px;
  border-top: 1px solid var.$color-border-gray;
}

.simpleLinkList_item {
  border-bottom: 1px solid var.$color-border-gray;
}

.simpleLinkList_link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 53px;
  position: relative;

  > span {
    flex-basis: calc(100% - 30px);
    flex-shrink: 0;
  }

  > span:nth-child(2) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
  }

  &::after {
    display: inline-block;
    content: '';
    width: 9px;
    height: 9px;
    border-right: 2px solid #58d1ca;
    border-bottom: 2px solid #58d1ca;
    transform: rotate(-45deg);
    margin-left: 16px;
    transition: border-color 0.1s;
  }
}

.simpleLinkList_label {
  padding: 0 10px;
  font-weight: 800;
  background-color: var.$color-red;
  color: #fff;
  line-height: 20px;
  font-size: 1rem;
}

.simpleLinkList.-sideNav {
  .simpleLinkList_link.-hasLabel {
    height: 75px;
    align-items: flex-start;
    > span:first-child {
      margin-top: 12.5px;
    }
    &::after {
      margin-top: 34.5px;
    }
    > span:nth-child(2) {
      top: auto;
      right: auto;
      transform: translateY(0);
      left: 0px;
      bottom: 12.5px;
    }
  }
}

.series {
  font-weight: 500;

  & + ::v-deep(.button) {
    margin-top: 40px;
  }

  .headingBand + & {
    margin-top: 0;
    border-top: none;
  }

  .simpleLinkList_link {
    height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 1.5;
    color: var.$color-main-text;

    &.current {
      color: inherit;

      &::after {
        opacity: 0;
        visibility: hidden;
      }
    }
  }
}
</style>
